// branding information

/**
 * these dashboards as a product name
 */
 export const productName = 'VigilancePro® Dashboards'

/**
 * short name for the brand of this product
 */
export const brand = 'ViPro®'

/**
 * long name for the brand of this product
 */
export const brandFull = 'VigilancePro®'

/**
 * short name of the company providing this product
 */
export const company = 'Vigilant'

/**
 * long name of the company providing this product
 */
export const companyFull = 'Vigilant Applications Limited'

/**
 * should the branding be shown in the footer?
 */
export const showBrandingInFooter = true

/**
 * Get the version number (using webpack trickery during transpilation)
 * @returns {String} the version number or '0' when not possible
 */
export const uiBuildVersion = () => process.env.PACKAGE_VERSION || '0'